module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels_BW_Web-p-130x130q80-5f6754a8cab327bdc99a64e00e8f557c.jpg";